import { BlogSection } from '@/types/blog';

export const quellenSection: BlogSection = {
  id: 'quellen',
  title: '',
  content: `
    <div class="mt-12 pt-8 border-t border-muted">
      <p class="text-sm text-muted-foreground mb-4">Quellen:</p>
      <p class="text-sm text-muted-foreground">Klontz, B. et al. (2011): Money Beliefs and Financial Behaviors. Journal of Financial Therapy.</p>
      <p class="text-sm text-muted-foreground">Deci, E. L. & Ryan, R. M. (2000): Self-Determination Theory and Human Needs.</p>
      <p class="text-sm text-muted-foreground">BaFin (2026): Definition der Anlageberatung und Standards zum Verbraucherschutz.</p>
      <p class="text-sm text-muted-foreground">Gewerbeordnung (GewO): §§ 34d, 34f, 34h, 34k – Gesetzliche Rahmenbedingungen für Vermittler.</p>
      <p class="text-sm text-muted-foreground">IHK Köln/Stuttgart (2026): Qualifikationsprofil Geprüfter Fachwirt für Finanzberatung (DQR-6 / Bachelor Professional).</p>
      <p class="text-sm text-muted-foreground">BGH (2025/2026): Urteile zur Unwirksamkeit von Coaching-Verträgen ohne ZFU-Zulassung.</p>
    </div>
  `
};
